import React, { ReactElement, ReactNode } from 'react';
import { GetStaticProps } from 'next';
import { getPageLayout, GlossaryPage } from '@/features';
import { PageType } from '@/types/page';
import { ScamCategoryType } from '@/types/scam-categories';

export const getStaticProps: GetStaticProps = async ({ params }) => {
  return {
    props: {
      tab: params?.tab,
    },
  };
};

export async function getStaticPaths() {
  const paths = Object.keys(ScamCategoryType).map((category) => ({
    params: {
      tab: category,
    },
  }));

  return {
    paths: paths,
    fallback: false,
  };
}

export default function Glossary(props: { tab: ScamCategoryType }): ReactNode {
  return <GlossaryPage initialTab={props.tab} />;
}

Glossary.getLayout = (page: ReactElement): ReactElement =>
  getPageLayout(page, PageType.GLOSSARY);
